module.exports = __webpack_public_path__ + "static/media/tornillos.bfca9033.svg";